export default __webpack_public_path__ + "static/telembLogo-979dad3d4af0d33ba740d4b0dc2ad061.png";